import { getRoundedFileSize } from './GetRoundedFileSize';

export { getRoundedFileSize };

export default getRoundedFileSize;
